export const virtualTagColorMap: { [key: string]: string } = {
  NEW: 'bg-[#FCA33A] text-white',
  DISCUSSION: 'bg-[#F65874] text-white',
  CONSENSUS: 'bg-[#7B61FF] text-white',
  CLOSED: 'bg-[#8C8D92] text-white',
};
